import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "../../contexts/themeContext";

function Intro() {
  const theme = useTheme();

  return (
    <IntroStyled theme={theme}>
      <h1>Produsele Noastre</h1>
    </IntroStyled>
  );
}

const IntroStyled = styled.div`
  width: 100%;
  padding: 50px 0 30px;

  @media (max-width: 500px) {
    padding-bottom: 10px;
  }

  h1 {
    text-align: center;
    font-size: 40px;
    font-weight: 600;
    font-family: "Helvetica Neue", sans-serif;
    color: ${props => props.theme.secondDark};

    @media (max-width: 500px) {
      width: 100%;
      text-align: center;
      font-size: 28px;
    }
  }
`;

export default Intro;
